// Tweaks floating panel — primary color, density, font, dark.
import { useState } from "react";
import { I } from "../shared/Icon";
import { useTheme } from "../shared/stores/theme";

export function Tweaks() {
  const [open, setOpen] = useState(false);
  const { primary, density, dark, font, set } = useTheme();

  return (
    <div className="t-tweaks">
      <button className="t-tweaks-btn" onClick={() => setOpen((o) => !o)} title="외관 설정">
        <I.Palette size={18}/>
      </button>
      {open && (
        <div className="t-tweaks-panel" onClick={(e) => e.stopPropagation()}>
          <h4>외관 설정</h4>

          <div className="t-tweaks-row">
            <label>색상</label>
            <div className="t-segment">
              <button className={primary === "blue" ? "active" : ""} onClick={() => set({ primary: "blue" })}>블루</button>
              <button className={primary === "purple" ? "active" : ""} onClick={() => set({ primary: "purple" })}>퍼플</button>
            </div>
          </div>

          <div className="t-tweaks-row">
            <label>밀도</label>
            <div className="t-segment">
              <button className={density === "compact" ? "active" : ""} onClick={() => set({ density: "compact" })}>좁게</button>
              <button className={density === "normal" ? "active" : ""} onClick={() => set({ density: "normal" })}>보통</button>
              <button className={density === "comfortable" ? "active" : ""} onClick={() => set({ density: "comfortable" })}>편하게</button>
            </div>
          </div>

          <div className="t-tweaks-row">
            <label>다크 모드</label>
            <div className="t-segment">
              <button className={!dark ? "active" : ""} onClick={() => set({ dark: false })}>라이트</button>
              <button className={dark ? "active" : ""} onClick={() => set({ dark: true })}>다크</button>
            </div>
          </div>

          <div className="t-tweaks-row">
            <label>폰트</label>
            <div className="t-segment">
              <button className={font === "pretendard" ? "active" : ""} onClick={() => set({ font: "pretendard" })}>Pretendard</button>
              <button className={font === "inter" ? "active" : ""} onClick={() => set({ font: "inter" })}>Inter</button>
              <button className={font === "system" ? "active" : ""} onClick={() => set({ font: "system" })}>System</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
